import { Box, Grid, Stack } from "@mui/material";
import { SLTypography } from "components/slTypography";
import { AboutUsLogo } from "helpers/enum/constants";

const AboutUsHead = () => {
  return (
    <>
      <Grid container>
        <Grid item lg={12} sx={{ paddingTop: { xs: "20px", sm: "0px" } }}>
          <SLTypography
            tabIndex={0}
            role="heading"
            variant="largeHeader"
            sx={{ fontSize: { xs: "19px", sm: "21px", md: "37px" } }}
          >
            About Us
          </SLTypography>
        </Grid>
        <Grid item lg={12}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ lg: "25px", md: "25px", sm: "20px", xs: "20px" }}
            sx={{
              paddingTop: { xs: "20px", sm: "25px", md: "40px" },
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={AboutUsLogo}
              sx={{ width: "120px" }}
              alt="soul link app logo"
              tabIndex={0}
            />
            <SLTypography
              tabIndex={0}
              variant="homeParagraphText"
              sx={{
                fontSize: { xl: "21px", sm: "18px", xs: "19px" },
                fontWeight: { xl: "500", sm: "600" },
                textAlign: { xl: "left", sm: "center" },
                marginTop: "10px",
              }}
            >
              Soul Link delivers a science-driven wellness and mental well-being
              experience designed to encourage cognitive engagement, emotional
              balance, and overall well-being.
              <br />
              <br /> By combining Restorative Music, Immersive Earth Videos, and
              Transformative Frequency Waves, Soul Link offers a non-invasive,
              multisensory approach rooted in emerging research on sound
              therapy, visual engagement, and cognitive entrainment. Designed to
              support mental, emotional, and physical well being. <br />
              <br /> Each session is designed to help clear the mind, feel more
              stable, and function at your best.
            </SLTypography>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default AboutUsHead;
